import React, { useEffect, useRef, useState } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import DownloadIcon from '@mui/icons-material/Download';
import GatewayLogo from '../../../assets/GatewayLogo/image.png';
import { getDDMMYYYY } from '../../../utils/dateTimeFormats';
import { Button, CircularProgress, useMediaQuery, useTheme } from '@mui/material';

const UserDataTable = ({ scannedData, ratingData, from, to }) => {
  const tableRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const handleMessage = (event) => {
      const data = event.data;
      if (data.type == 'fileDownloaded') {
        setIsLoading(false);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const styles = {
    header: {
      backgroundColor: '#f2f2f2',
      borderBottom: '1px solid #ddd',
      borderRight: '1px solid #ddd', // Column border
      padding: '8px',
      textAlign: 'left',
    },
    dateCell: {
      borderBottom: '1px solid #ddd',
      borderRight: '1px solid #ddd', // Column border
      padding: '8px',
      textAlign: 'left',
      fontWeight: 'bold', // Make text bold
    },
    cell: {
      borderBottom: '1px solid #ddd',
      borderRight: '1px solid #ddd', // Column border
      padding: '8px',
      textAlign: 'left',
    },
    totalRow: {
      backgroundColor: '#e6e6e6',
    },
    totalCell: {
      borderBottom: '1px solid #ddd',
      borderRight: '1px solid #ddd', // Column border
      padding: '8px',
      textAlign: 'left',
    },
    overallRatingCell: {
      borderBottom: '1px solid #ddd',
      borderRight: '1px solid #ddd', // Column border
      padding: '8px',
      textAlign: 'center',
      fontWeight: 'bold',
    },
  };

  // const generatePDF = () => {
  //   const input = tableRef.current;

  //   html2canvas(input).then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const imgWidth = 210; // A4 width in mm
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  //     pdf.save('table.pdf');
  //   });
  // };

  // const generatePDF = () => {
  //   setIsLoading(true);
  //   const input = tableRef.current;

  //   html2canvas(input).then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const imgWidth = 210; // A4 width in mm
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

  //     // Get base64 string of the PDF
  //     const pdfBase64 = pdf.output('datauristring'); // "data:application/pdf;base64,..."
  //     console.log('pdfBase64', pdfBase64);
  //     // Send it to React Native
  //     window['ReactNativeWebView'] &&
  //       window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'pdf', data: pdfBase64 }));
  //   });
  // };

const generatePDFDesktop = () => {
  const input = tableRef.current;

  html2canvas(input, { scale: 2 }).then((canvas) => {
    const pdf = new jsPDF('p', 'mm', 'a4');

    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    const imgHeight = (canvasHeight * imgWidth) / canvasWidth;

    const pageCanvasHeight = (pageHeight * canvasWidth) / imgWidth;

    let position = 0;

    const totalPages = Math.ceil(canvasHeight / pageCanvasHeight);

    for (let page = 0; page < totalPages; page++) {
      const pageCanvas = document.createElement('canvas');
      pageCanvas.width = canvasWidth;
      pageCanvas.height = pageCanvasHeight;

      const pageCtx = pageCanvas.getContext('2d');

      // Draw the current page slice
      pageCtx.drawImage(
        canvas,
        0,
        page * pageCanvasHeight,
        canvasWidth,
        pageCanvasHeight,
        0,
        0,
        canvasWidth,
        pageCanvasHeight
      );

      const imgData = pageCanvas.toDataURL('image/png');
      if (page > 0) pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, pageHeight);
    }

    pdf.save('table.pdf');
  });
};

const generatePDFMobile = () => {
  setIsLoading(true);
  const input = tableRef.current;

  html2canvas(input, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');

    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    // Add first page
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Add more pages if necessary
    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    const pdfBase64 = pdf.output('datauristring');
    window['ReactNativeWebView']?.postMessage(
      JSON.stringify({ type: 'pdf', data: pdfBase64 })
    );

    // Or for web download directly
    // pdf.save('table.pdf');

    setIsLoading(false);
  });
};


  return (
    <div>
      {scannedData?.filteredData ? (
        <div className="text-center" style={{ textAlign: 'center' }}>
          <div ref={tableRef} style={{}}>
            <div
              style={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexDirection: 'column',
                paddingBottom: '10px',
              }}
            >
              <img
                src={GatewayLogo}
                alt="logo"
                style={{
                  maxHeight: '110px',
                  maxWidth: '130px',
                  paddingBottom: '10px',
                }}
              />
              <div>
                <span style={{ fontWeight: '600' }}>From :</span>
                {' ' + from + ' '}
                <span style={{ fontWeight: '600' }}>To :</span>
                {' ' + to}
              </div>
            </div>
            <table style={{ borderCollapse: 'collapse', width: '80%', fontSize: '12px', margin: '0px auto' }}>
              <thead>
                <tr>
                  <th style={styles.header}>Date</th>
                  <th style={styles.header}>Morning</th>
                  <th style={styles.header}>Evening</th>
                  <th style={styles.header}>Snack</th>
                  <th style={styles.header}>Healthy</th>
                </tr>
              </thead>
              <tbody>
                {scannedData?.filteredData?.map((item, index) => (
                  <tr key={index}>
                    <td style={styles.dateCell}>{getDDMMYYYY(item.date)}</td>
                    <td style={styles.cell}>{item.count.morningTea}</td>
                    <td style={styles.cell}>{item.count.eveningTea}</td>
                    <td style={styles.cell}>{item.count.snack}</td>
                    <td style={styles.cell}>{item.count.healthy}</td>
                  </tr>
                ))}
                <tr style={styles.totalRow}>
                  <td style={styles.dateCell}>Total</td>
                  <td style={styles.totalCell}>{scannedData?.totalCount.total?.morningTea}</td>
                  <td style={styles.totalCell}>{scannedData?.totalCount.total?.eveningTea}</td>
                  <td style={styles.totalCell}>{scannedData?.totalCount.total?.snack}</td>
                  <td style={styles.totalCell}>{scannedData?.totalCount.total?.healthy}</td>
                </tr>

                <tr>
                  <td style={styles.dateCell}>Ratings</td>
                  <td style={styles.cell}>{ratingData?.morningTeaAvg || '-'}</td>
                  <td style={styles.cell}>{ratingData?.eveningTeaAvg || '-'}</td>
                  <td style={styles.cell}>{ratingData?.snackAvg || '-'}</td>
                  <td style={styles.cell}>{ratingData?.healthyAvg || '-'}</td>
                </tr>

                <tr style={styles.totalRow}>
                  <td style={styles.dateCell}>Overall Ratings</td>
                  <td style={styles.overallRatingCell} colSpan={4}>
                    {ratingData?.overallAverage || '-'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Button
            fullWidth
            variant="contained"
            color="success"
            sx={{ marginTop: 1, borderRadius: '30px' }}
            onClick={() => isSm ? generatePDFMobile() : generatePDFDesktop()}
            aria-label="download-pdf"
          >
            {isLoading ? (
              <CircularProgress size={24} color="secondary" />
            ) : (
              <>
                <DownloadIcon /> Download
              </>
            )}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default UserDataTable;
